module.exports = function(data) {
    this._sendMessage('publishToOthers', data);
};
